// Synchronisation de la hauteur des thumbnails avec l'image principale
function syncThumbnailHeight() {
  if (window.innerWidth >= 768) {
    // Pour tablette ET desktop
    const mainCarousel = document.querySelector('.template-product .main-carousel .splide__track');
    const thumbnailCarousel = document.querySelector('.template-product .gallery_layout-left .thumbnail-carousel');
    const thumbnailTrack = document.querySelector('.template-product .thumbnail-carousel .splide__track');
    const thumbnailList = document.querySelector('.template-product .thumbnail-carousel .splide__list');

    if (mainCarousel && thumbnailCarousel && thumbnailTrack) {
      const mainCarouselHeight = mainCarousel.offsetHeight;

      if (mainCarouselHeight > 0) {
        // Forcer la hauteur des thumbnails à celle du carousel principal
        thumbnailCarousel.style.setProperty('height', mainCarouselHeight + 'px', 'important');
        thumbnailTrack.style.setProperty('height', mainCarouselHeight + 'px', 'important');

        // Forcer la hauteur de la liste des thumbnails
        if (thumbnailList) {
          thumbnailList.style.setProperty('height', mainCarouselHeight + 'px', 'important');
        }

        // S'assurer que le conteneur parent respecte aussi cette hauteur
        const mediaList = document.querySelector('.template-product .product__media-list.gallery_layout-left');
        if (mediaList) {
          mediaList.style.setProperty('grid-template-rows', mainCarouselHeight + 'px', 'important');
        }
      }
    }
  }
}

// Attendre que Splide soit initialisé
function waitForSplide() {
  const checkSplide = setInterval(() => {
    const mainCarousel = document.querySelector('.template-product .main-carousel .splide__track');
    if (mainCarousel && mainCarousel.offsetHeight > 0) {
      clearInterval(checkSplide);
      syncThumbnailHeight();
    }
  }, 100);

  // Timeout après 5 secondes
  setTimeout(() => clearInterval(checkSplide), 5000);
}

// Exécuter au chargement de la page
document.addEventListener('DOMContentLoaded', waitForSplide);

// Exécuter lors du redimensionnement de la fenêtre
window.addEventListener('resize', () => {
  setTimeout(syncThumbnailHeight, 100);
});

// Exécuter après le chargement des images
window.addEventListener('load', () => {
  setTimeout(syncThumbnailHeight, 200);
});

// Observer les changements de taille du carousel principal
if (window.ResizeObserver) {
  const observer = new ResizeObserver(() => {
    syncThumbnailHeight();
  });

  // Observer le carousel principal une fois qu'il existe
  const checkForCarousel = setInterval(() => {
    const mainCarousel = document.querySelector('.template-product .main-carousel .splide__track');
    if (mainCarousel) {
      observer.observe(mainCarousel);
      clearInterval(checkForCarousel);
    }
  }, 100);
}